// extracted by mini-css-extract-plugin
module.exports = {"validation":"ValidationList_validation__tNV60","lastValidation":"ValidationList_lastValidation__2z7YY"};